// "Converted from Proposal" provenance pill shown at the top of the
// WO form when this WO was generated from an accepted proposal.
// Clicking it navigates back to the source proposal, carrying
// state so the user can come back to this WO afterwards.
// Extracted from WorkOrderTab.jsx (Feb 2026, iter182).
export function WOSourceProposalBadge({ form, editingWO, clientId, navigate }) {
  if (!form.proposal_id) return null;
  return (
    <div className="flex items-center gap-2">
      <button
        className="inline-flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-green-50 text-green-700 border border-green-200 text-xs font-medium hover:bg-green-100 transition-colors cursor-pointer"
        onClick={() =>
          navigate("/proposals", {
            state: {
              viewProposalId: form.proposal_id,
              returnToWO: { clientId, woId: editingWO?.id },
            },
          })
        }
        data-testid="btn-view-source-proposal"
      >
        Converted from Proposal <span className="text-green-500">&rarr;</span>
      </button>
    </div>
  );
}
